var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DFFCF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7211 9.92893C15.7211 9.56995 15.4301 9.27893 15.0711 9.27893L9.22107 9.27893C8.86208 9.27893 8.57107 9.56995 8.57107 9.92893C8.57107 10.2879 8.86208 10.5789 9.22107 10.5789L14.4211 10.5789L14.4211 15.7789C14.4211 16.1379 14.7121 16.4289 15.0711 16.4289C15.4301 16.4289 15.7211 16.1379 15.7211 15.7789L15.7211 9.92893ZM8.45962 17.4596L15.5307 10.3886L14.6114 9.46931L7.54038 16.5404L8.45962 17.4596Z",
    fill: "#00AB72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgraph);
export default __webpack_public_path__ + "static/media/upgraph.e06d994068930defd86273a1e7176bc1.svg";
export { ForwardRef as ReactComponent };